import React, { useState, useEffect } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Grid,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import Header from "../../../components/Header";
import { useGetPermissionsQuery } from "../../../state/api";
import { useDispatch } from "react-redux";
import { updateRoleAction } from "../../../redux/actions/roleAction";

import { toast } from "react-toastify";
import { getRoleActionFn } from "../../../redux/actions/roleAction";

import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import * as yup from "yup";

const validationSchema = yup.object().shape({
  title: yup.string().required("Title is required"),
  isActive: yup.boolean().required("Select status"),
  category: yup.string().required("Category is required to create a role"),
  // selectPermissions: yup.array().required("Select a permissions"),
});

const EditRole = () => {
  const {
    data: permissions = [],
    isLoading,
    isError,
  } = useGetPermissionsQuery();

  const location = useLocation();
  const { pathname } = location;
  const roleId = pathname.split("/").pop();
  // const { role } = location.state || {};
  // const _id = role ? role._id : null;
  const [err, setErr] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const initialFormState = {
    title: "",
    category: "",
    isActive: "",
    selectPermissions: [],
    // roleId: roleId,
  };

  const [formData, setFormData] = useState(initialFormState);
  const [checkedItems, setCheckedItems] = useState([]);

  // useEffect(() => {
  //   if (role && permissions.length > 0) {
  //     const formData = {
  //       ...role,
  //       selectPermissions: role.permissions || [],
  //     };

  //     setFormData(formData);
  //     // console.log(role.permissions);
  //     const initialCheckedItems = role.permissions.reduce((acc, permission) => {
  //       acc[permission._id] = true;
  //       return acc;
  //     }, {});

  //     // console.log(initialCheckedItems);

  //     setCheckedItems(initialCheckedItems);
  //   }
  // }, [role, permissions]);

  useEffect(() => {
    const fetchRoleDetails = async () => {
      try {
        const response = await dispatch(getRoleActionFn(roleId));

        if (response && response.success) {
          const roleDetails = response.data;
          setFormData(roleDetails);
          const initialCheckedItems = roleDetails.permissions.reduce(
            (acc, permission) => {
              acc[permission._id] = true;
              return acc;
            },
            {}
          );
          setCheckedItems(initialCheckedItems);
        } else {
          console.log("Failed to fetch role details");
          toast.error(response.message || "Failed to fetch role details");
        }
      } catch (error) {
        console.error("Error fetching role details", error);
        toast.error("Error fetching role details");
      }
    };

    fetchRoleDetails();
  }, [roleId, dispatch]);

  const handleBlur = async (e) => {
    const fieldName = e.target.name;
    try {
      await validationSchema.validateAt(fieldName, formData);
      setErr({ ...err, [fieldName]: "" });
    } catch (error) {
      setErr({ ...err, [fieldName]: error.message });
    }
  };

  const handleCheckboxChange = (event) => {
    const itemId = event.target.name;
    const isChecked = event.target.checked;

    setCheckedItems((prevCheckedItems) => ({
      ...prevCheckedItems,
      [itemId]: isChecked,
    }));
  };

  const handleSelectAll = (category, checked) => {
    const updatedCheckedItems = { ...checkedItems };

    permissions.forEach((permission) => {
      if (permission.table === category) {
        updatedCheckedItems[permission._id] = checked;
      }
    });

    setCheckedItems(updatedCheckedItems);
  };

  const groupedPermissions = permissions.reduce((groups, permission) => {
    const table = permission.table;

    if (!groups[table]) {
      groups[table] = [];
    }

    groups[table].push(permission);
    return groups;
  }, {});

  const groupsArray = Object.entries(groupedPermissions);
  const itemsPerRow = 5;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const selectedPermissions = Object.entries(checkedItems)
      .filter(([_, isChecked]) => isChecked)
      .map(([roleId, _]) => roleId);

    const updatedFormData = {
      ...formData,
      selectPermissions: selectedPermissions,
    };
    try {
      await validationSchema.validate(
        { ...formData, table: formData.table },
        { abortEarly: false }
      );
      console.log("roleId", roleId);
      const response = await dispatch(
        updateRoleAction(roleId, updatedFormData)
      );
      // console.log("Data submitted:", response);
      if (response) {
        toast.success("Role updated successfully");
        navigate("/role");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error("Failed to update role");
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      toast.error(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <Box mt="1.5rem" mb="2.5rem" ml="2.5rem" mr="2.5rem">
      <Header title="EDIT ROLE" />
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth margin="normal">
          {/* TITLE */}
          <TextField
            label="Title"
            name="title"
            value={formData.title}
            onBlur={handleBlur}
            onChange={handleChange}
            margin="normal"
          />
          {err.title && (
            <Grid item>
              <Typography color="error">{err.title}</Typography>
            </Grid>
          )}{" "}
          {/* CATEGORY */}
          <TextField
            label="Category"
            name="category"
            value={formData.category}
            onBlur={handleBlur}
            onChange={handleChange}
            margin="normal"
          />
          {err.category && (
            <Grid item>
              <Typography color="error">{err.category}</Typography>
            </Grid>
          )}{" "}
          {/* IS ACTIVE */}
          <FormControl fullWidth variant="outlined" margin="normal">
            <InputLabel>Is Active</InputLabel>
            <Select
              name="isActive"
              value={formData.isActive}
              onBlur={handleBlur}
              onChange={handleChange}
            >
              {/* <MenuItem value="">
                <em>Select</em>
              </MenuItem> */}
              <MenuItem value={true}>True</MenuItem>
              <MenuItem value={false}>False</MenuItem>
            </Select>
            {err.isActive && (
              <Grid item>
                <Typography color="error">{err.isActive}</Typography>
              </Grid>
            )}{" "}
          </FormControl>
          {/* PERMISSION */}
          <h3>Select Permissions</h3>
          <div>
            {groupsArray
              .map(([table, permissionsInTable], index) => (
                <Box
                  key={table}
                  // border="1px solid #ccc"
                  padding="10px"
                  marginBottom="20px"
                  // marginRight="10px"
                  style={{ width: `${100 / itemsPerRow}%` }}
                >
                  <h3>{table}</h3>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={
                          permissionsInTable.every(
                            (permission) =>
                              checkedItems[permission._id] || false
                          ) && permissionsInTable.length > 0
                        }
                        onChange={(event) =>
                          handleSelectAll(table, event.target.checked)
                        }
                      />
                    }
                    label="Select All"
                  />
                  <FormGroup>
                    {permissionsInTable.map((permission) => (
                      <FormControlLabel
                        key={permission._id}
                        control={
                          <Checkbox
                            checked={checkedItems[permission._id] || false}
                            onBlur={handleBlur}
                            onChange={handleCheckboxChange}
                            name={permission._id}
                          />
                        }
                        label={permission.title}
                      />
                    ))}
                  </FormGroup>
                </Box>
              ))
              .reduce((rows, element, index) => {
                if (index % itemsPerRow === 0) rows.push([]);
                rows[rows.length - 1].push(element);
                return rows;
              }, [])
              .map((row, index) => (
                <Box key={index} display="flex" flexDirection="row">
                  {row}
                </Box>
              ))}
            {err.selectPermissions && (
              <Grid item>
                <Typography color="error">{err.selectPermissions}</Typography>
              </Grid>
            )}{" "}
          </div>
          {/* SUBMIT BUTTON */}
          <Grid container justifyContent="center" alignItems="center">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SendIcon />}
            >
              Submit
            </Button>
          </Grid>
        </FormControl>
      </form>
    </Box>
  );
};

export default EditRole;
